import { EmptyState as EmptyStateBase } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const EmptyState = () => {
  const { t } = useI18n();

  return (
    <EmptyStateBase
      text={t('web.notifications.nonotifications.1')}
      subText={t('web.notifications.nonotifications.2')}
      classNames={{
        containerClassName: styles.container,
        textClassName: styles.text,
        subTextClassName: styles.subText
      }}
    />
  );
};
